const plansHash = {
  'Simple Start': '1',
  Standard: '2',
  Premium: '3',
};
export default plansHash;
